<template>
	<div
		class="horizontal-decor-divider"
		:class="[
			`horizontal-decor-divider--${withSides ? 'with' : 'without'}-sides`,
			{ 'horizontal-decor-divider--centered': isCentered },
		]"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			:viewBox="`0 0 953.8 ${withSides ? 19.8 : 4}`"
			preserveAspectRatio="none"
		>
			<g v-if="withSides" id="end-left">
				<path
					:class="fillClass"
					d="M9.9,0L0,9.9l9.9,9.9,7.9-7.9v-4L9.9,0ZM9.9,14.14l-4.24-4.24,4.24-4.24,4.25,4.24-4.25,4.24Z"
				/>
			</g>
			<g id="middle">
				<rect
					:class="fillClass"
					:x="withSides ? 17.8 : 0"
					:y="withSides ? 7.9 : 0"
					:width="withSides ? 918.2 : 1000"
					height="4"
				/>
			</g>
			<g v-if="withSides" id="end-right">
				<path
					:class="fillClass"
					d="M943.9,0l-7.9,7.9v4l7.9,7.9,9.9-9.9-9.9-9.9ZM939.66,9.9l4.24-4.24,4.25,4.24-4.25,4.24-4.24-4.24Z"
				/>
			</g>
		</svg>
	</div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

interface Props {
	withSides?: boolean;
	isCentered?: boolean;
	isGolden?: boolean;
	isRed?: boolean;
}
const {
	withSides = true,
	isCentered = false,
	isGolden = false,
	isRed = false,
} = defineProps<Props>();

const fillClass = computed((): `cls-${number}` => {
	if (isGolden) return "cls-2";
	if (isRed) return "cls-3";
	return "cls-1";
});
</script>

<style lang="scss" scoped>
.horizontal-decor-divider {
	display: flex;
	position: relative;
	z-index: 0;
	width: 100%;

	&--with-sides {
		height: 0.5rem;
	}

	&--without-sides {
		height: 0.125rem;
	}

	&--centered {
		justify-content: center;
	}

	.cls-1 {
		fill: #4b4b50;
	}

	.cls-2 {
		fill: #c4951e;
	}
	.cls-3 {
		fill: #8f151d;
	}
}
</style>
